<!-- Survey List Table -->
<div class="card table-container">
    <div class="card-body" id="item_card_body">
     <div class="card-title" id="survey_list_heading">{{ 'SurveyList.surveyListHeading' | translate}} ( {{surveyCount}} )
        </div>
        <ul class="list-group list-group-flush" *ngIf="surveyListResponse" id="c_survey_list">
            <li  *ngFor="let survey of surveyListResponse" (click)="openDetailView(survey)" class="list-group-item"
            [ngClass]="( requestId && survey.requestId == requestId) ? 'list-group-item-secondary' :
                       ( !requestId && survey.surveyId == id)? 'list-group-item-secondary': ''" >
                <span id="survey_request_id" *ngIf="survey.requestId">{{'SurveyList.feedback' | translate}} {{ survey.requestId }}</span> 
                <p><span>{{survey.surveyTitle}}</span></p>
            </li>
            <li id="no_survey_found" *ngIf="!surveyListResponse || surveyListResponse.length==0" >
                <span>{{'SurveyList.noSurvey' | translate}}</span>
            </li>
        </ul>
    </div>
</div>